import { useState } from 'react';
import { FirstStep } from './components/FirstStep/FirstStep';
import { SecondStep } from './components/SecondStep/SecondStep';
import { CredentialsPageContainer } from 'components';

export const ForgotPassword = () => {
  const [isLastStep, setIsLastStep] = useState(false);
  const [email, setEmail] = useState('');
  return (
    <CredentialsPageContainer
      formTitle="Forgot password?"
      formSubtitle={
        isLastStep
          ? 'Please confirm your email address and set up your new password'
          : 'No worries, we will send you reset instructions by email'
      }>
      {isLastStep ? (
        <SecondStep userEmail={email} />
      ) : (
        <FirstStep goToNextStep={() => setIsLastStep(true)} setUserEmail={setEmail} />
      )}
    </CredentialsPageContainer>
  );
};
